<template>
  <div class="myhome-header__button">
    <h3 v-if="role === 'ROLE_STUDENT' || role === 'ROLE_TEACHER'" class="dea-heading--medium__m">
      Se hai già una copia di un libro tra le mani,<br />
      attivala subito!
    </h3>
    <h3 v-if="role === 'ROLE_PARENT'" class="dea-heading--medium__m">
      Avete già una copia di un libro?<br />
      Attivala subito!
    </h3>
    <Buttons
      class="dea-button dea-button--large dea-button--iconRight"
      type="a"
      target="_blank"
      :data-test="`activation-copy-trigger-${role}`"
      :href="$root.config.activation_search_url"
      @click="$emit('open-activation-modal')"
    >
      Attiva libro
    </Buttons>
  </div>
</template>

<script>
import Buttons from "deascuola-storybook/src/components/elements/Buttons";

export default {
  name: "ButtonActivateCopy",
  components: { Buttons },
  props: {
    linkColor: {
      type: String,
      default: "",
    },
    role: {
      type: String,
      default: "ROLE_TEACHER",
    },
  },
};
</script>
